import Button from '../../../../../components/Button'
import useResize from '../../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../../utils/constants'
import { TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS } from '../../../constants'

const TabBarUploadVideoTalent = ({ tabBarValue, setTabBarValue }) => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const disabledButton = false
  const handleButtonClick = (button) => {
    setTabBarValue(button)
  }

  return (
    <div className="bg-on-bg-brand p-2 rounded gap-2 mt-3">
      <div className="d-flex justify-content-center align-items-center overflow-auto">
        <Button
          className={`${
            tabBarValue === TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.instructions
              ? 'bg-bg-CTA-primary'
              : 'bg-on-bg-brand'
          } text-on-bg-primary ${isMobile ? 'font-extra-small' : 'font-small'}`}
          onClick={() =>
            handleButtonClick(TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.instructions)
          }
        >
          {TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.instructions}
        </Button>
        <Button
          className={`${
            tabBarValue === TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.example
              ? 'bg-bg-CTA-primary'
              : 'bg-on-bg-brand'
          } text-on-bg-primary ${
            isMobile ? 'font-extra-small' : 'font-small'
          } ${disabledButton ? 'isDisabledButton' : ''}`}
          onClick={() =>
            handleButtonClick(TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.example)
          }
          disabled={disabledButton}
        >
          {TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.example}
        </Button>
        <Button
          className={`${
            tabBarValue === TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.delivery
              ? 'bg-bg-CTA-primary'
              : 'bg-on-bg-brand'
          } text-on-bg-primary ${isMobile ? 'font-extra-small' : 'font-small'} ${disabledButton ? 'isDisabledButton' : ''}`}
          onClick={() =>
            handleButtonClick(TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.delivery)
          }
          disabled={disabledButton}
        >
          {TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.delivery}
        </Button>
      </div>
    </div>
  )
}

export default TabBarUploadVideoTalent
